import { privateFetch } from "api/privateFetch";

/**
 * List students
 * @param {number} csmId CSM ID
 * @param {string} studentType Student Type
 * @returns {Promise<Object[]>} Response
 */
const listStudents = async (csmId, studentType = "all") => {
  const { data } = await privateFetch.get(`csm/${csmId}/liststudents`, {
    params: {
      studentType,
    },
  });
  return data;
};

export default listStudents;
